/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Model_Made_WithInputs */

const en_model_made_with = /** @type {(inputs: Model_Made_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Written with ${i?.model}`)
};

const id_model_made_with = /** @type {(inputs: Model_Made_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ditulis dengan ${i?.model}`)
};

/**
* | output |
* | --- |
* | "Written with {model}" |
*
* @param {Model_Made_WithInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_made_with = /** @type {((inputs: Model_Made_WithInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Made_WithInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_made_with(inputs)
	return en_model_made_with(inputs)
});